import { memo } from 'react';
import {
  ModularBenefitCustomModalType,
  type IModularBenefitDetail,
} from '@ben/shared/types/columbia';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import useSetDirtyValue from '../hooks/use-set-dirty-value';
import {
  DEFAULT_CHANGE_CONTENT,
  DEFAULT_OPT_IN_CONTENT,
  DEFAULT_OPT_OUT_CONTENT,
} from './constants';
import { Header } from './header';
import { ModalForm } from './modal-form';
import { Container } from './opt-in-out-modal.styles';

const DEFAULT_CONTENT_BY_TYPE = {
  [ModularBenefitCustomModalType.OPT_IN]: DEFAULT_OPT_IN_CONTENT,
  [ModularBenefitCustomModalType.OPT_OUT]: DEFAULT_OPT_OUT_CONTENT,
  [ModularBenefitCustomModalType.CHANGE]: DEFAULT_CHANGE_CONTENT,
};

const OptInOutModal = () => {
  const { getValues } = useFormContext<IModularBenefitDetail>();
  const setDirtyValue = useSetDirtyValue<IModularBenefitDetail>();
  const customModals = useWatch({ name: 'customModals', exact: true });

  const handleSelectModal = (type: ModularBenefitCustomModalType) => {
    const current = getValues('customModals');
    setDirtyValue('customModals', [
      ...(Array.isArray(current) ? current : []),
      {
        type,
        ...DEFAULT_CONTENT_BY_TYPE[type],
      },
    ]);
  };

  const handleRemoveModal = (type: ModularBenefitCustomModalType) => {
    const current = getValues('customModals');
    const next = (Array.isArray(current) ? current : []).filter(
      (modal) => modal.type !== type
    );
    setDirtyValue('customModals', next);
  };

  return (
    <Container>
      <Controller
        name="customModals"
        render={() => <span style={{ display: 'none' }} />}
      />
      <Header onAddModal={handleSelectModal} customModals={customModals} />
      {customModals?.map(
        (modal: { type: ModularBenefitCustomModalType }, index: number) => (
          <ModalForm
            key={modal.type}
            index={index}
            type={modal.type}
            onRemove={handleRemoveModal}
          />
        )
      )}
    </Container>
  );
};

export default memo(OptInOutModal);
